import {FC} from "react";
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import ErrorIcon from "@mui/icons-material/ErrorOutlineOutlined";

type ErrorFallbackUIProps = {
  error: Error;
  resetErrorBoundary: () => void;
  fullPage: boolean;
};
export const ErrorFallbackUI: FC<ErrorFallbackUIProps> = ({
  error,
  resetErrorBoundary,
  fullPage,
}) => {
  const theme = useTheme();

  const containerStyles = fullPage
    ? {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        p: 3,
        bgcolor: theme.palette.background.default,
      }
    : {p: 2};

  return (
    <Box role="alert" sx={containerStyles}>
      <Alert
        severity="error"
        icon={<ErrorIcon fontSize="large" />}
        sx={{
          maxWidth: 600,
          width: "100%",
          boxShadow: theme.shadows[8],
          "& .MuiAlert-message": {width: "100%"},
        }}>
        <AlertTitle sx={{typography: "h5"}}>Application Error</AlertTitle>

        <Typography variant="body1" component="p">
          We've encountered an unexpected error. Our team has been notified.
        </Typography>

        <Typography
          variant="caption"
          component="pre"
          sx={{
            bgcolor: theme.palette.grey[100],
            p: 1.5,
            borderRadius: 1,
            overflowX: "auto",
            mb: 2,
            fontFamily: "monospace",
          }}>
          {error.message}
        </Typography>

        <Stack direction="row" spacing={2} flexWrap="wrap">
          <Button
            variant="contained"
            onClick={resetErrorBoundary}
            sx={{mt: 1, flexGrow: 1}}>
            Retry Operation
          </Button>
          <Button
            variant="outlined"
            onClick={() => window.location.reload()}
            sx={{mt: 1, flexGrow: 1}}>
            Reload Page
          </Button>
        </Stack>
      </Alert>
    </Box>
  );
};
